export default () => {

  $('.mobile-menu-trigger').click((e) => {
    $('body').toggleClass('-mobile-menu-open');
    $('.mobile-menu').toggleClass('-open');
    $(e.currentTarget).toggleClass('-active');
  });

  $('.mobile-menu a').click(() => {
    $('body').removeClass('-mobile-menu-open');
    $('.mobile-menu').removeClass('-open');
    $('.mobile-menu-trigger').removeClass('-active');
  });

};
